import React, { useRef, useEffect } from "react";

import {
  // BG,
  SidebarWrapper,
  SideTopGrouping,
  SideTab,
  TabItem,
  Title,
  Icon,
  IconImg,
  TabItemSelected,
  MarvinWrapper,
} from "./styles";

const SidebarPopUp = (props) => {
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          props.hideSidebar();
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef();
  useOutsideAlerter(wrapperRef);

  return (
    // <BG onClick={props.hideSidebar}>
    <SidebarWrapper ref={wrapperRef}>
      <SideTopGrouping>
        <MarvinWrapper to="/dashboard">
          <img src="/images/components/Sidebar/SideLogo.svg" alt="sideLogo" />{" "}
        </MarvinWrapper>
        <SideTab>
          {props.tab === "meet" ||
          props.tab === "meetMT" ||
          props.tab === "meetCT" ||
          props.tab === "meetWR" ? (
            <TabItemSelected to="/dashboard" onClick={props.meetOptionHandler}>
              <Title>Meet</Title>
              <Icon>
                <IconImg src="/images/components/Sidebar/MeetSelected.svg" />
              </Icon>
            </TabItemSelected>
          ) : (
            <TabItem to="/dashboard" onClick={props.meetOptionHandler}>
              <Title>Meet</Title>
              <Icon>
                <svg
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask1"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="23"
                    height="23"
                  >
                    <circle cx="11.5" cy="11.5" r="11.5" fill="#333333" />
                  </mask>
                  <g mask="url(#mask1)">
                    <path
                      id="changedColor"
                      d="M-9.72562 10.5178L-9.72569 10.518C-9.86503 10.9025 -9.84221 11.2737 -9.66682 11.7269C-9.47992 12.2098 -9.13783 12.7402 -8.66781 13.4143C-8.58342 13.5354 -8.49578 13.6598 -8.40561 13.7879C-7.51631 15.0506 -6.37947 16.6648 -5.65408 18.8658L-5.65405 18.8659C-4.80689 21.4377 -4.8878 23.7669 -5.03725 28.0694L-5.04135 28.1877L-5.04136 28.1878C-5.04424 28.2703 -5.0476 28.3572 -5.05111 28.4483C-5.10755 29.9107 -5.20593 32.4599 -4.07675 35.4765C-4.00309 35.6732 -3.93902 35.8363 -3.88976 35.9597C-3.87321 36.0012 -3.85687 36.0418 -3.84197 36.0788C-3.81671 36.1415 -3.79561 36.1939 -3.78473 36.2227L-3.78382 36.2252C-2.65424 39.2536 -0.270323 41.5036 2.05944 43.0777C4.38153 44.6466 6.58062 45.4976 7.24886 45.756L7.24918 45.7561C9.94459 46.7999 12.7802 47.3342 15.6033 47.3319C18.7027 47.318 20.9391 46.6379 21.3834 46.4993C23.4209 45.8624 24.9698 44.9701 25.8278 44.4691C26.3213 44.1808 26.5976 43.9852 26.8549 43.8023L26.867 43.7938C27.1313 43.606 27.3902 43.422 27.8159 43.1867C27.816 43.1867 27.816 43.1866 27.8161 43.1866L28.1707 43.8167C29.1905 43.2525 31.4364 42.0314 34.4969 41.5401C36.141 41.2761 37.0065 41.3873 38.0531 41.5217C38.9549 41.6376 39.991 41.7706 41.7752 41.696L-9.72562 10.5178ZM-9.72562 10.5178C-9.49847 9.89042 -8.93396 9.53676 -8.21632 9.14228L-8.21628 9.14226C-5.5044 7.65135 -2.85244 7.47938 0.211271 7.54851C0.78586 7.56147 1.37597 7.58313 1.98294 7.6054C4.5942 7.70123 7.5176 7.80851 10.8604 7.28461L10.8606 7.28458C13.4809 6.87327 15.5885 6.19296 17.4426 5.5945C18.0439 5.40042 18.6185 5.21493 19.1753 5.05003C21.4553 4.37479 23.5217 4.00801 26.2096 4.61079L26.2102 4.6109C26.9235 4.77033 28.464 5.17423 30.0234 5.63458L30.0235 5.6346C33.4544 6.64701 36.8094 7.7885 38.4984 8.65118L38.4991 8.65157C40.8111 9.82914 47.2353 13.2245 51.2867 20.4454L-9.72562 10.5178Z"
                      stroke="#A2AECB"
                      strokeWidth="1.5"
                    />
                    <path
                      id="changedColor"
                      d="M16.7284 42.8841L16.7283 42.8841C13.8593 43.2956 11.4916 42.6673 9.62624 42.0935C8.21026 41.6572 6.02432 40.9822 3.90419 39.8318C1.78027 38.6794 -0.205868 37.0876 -1.29259 34.8592L-1.2927 34.859C-1.65088 34.1251 -1.78477 33.5554 -1.82135 33.0226C-1.85695 32.504 -1.80369 32.0041 -1.73404 31.3503C-1.72899 31.303 -1.72387 31.2549 -1.71868 31.2059C-1.56403 29.7446 -1.41054 27.8614 -2.22242 24.5849L-2.22242 24.5849C-2.87463 21.9531 -4.02718 18.8697 -4.38739 17.9061L-4.39331 17.8902L-4.39346 17.8898C-5.18078 15.7873 -5.74244 14.5492 -6.09895 13.7633C-6.15539 13.6389 -6.20669 13.5258 -6.25293 13.4224C-6.42783 13.0314 -6.50004 12.8422 -6.52785 12.7119C-6.54531 12.6301 -6.54565 12.5789 -6.51005 12.4618C-6.37958 12.0335 -6.03207 11.7326 -5.08199 11.5526C-4.23743 11.3926 -3.13213 11.3703 -1.7399 11.3422C-1.53924 11.3381 -1.33262 11.334 -1.11996 11.3292C2.1935 11.2556 6.644 11.0434 11.3966 8.7848L11.3967 8.78476C11.9475 8.52291 12.4877 8.24286 13.0298 7.96178C15.1416 6.86679 17.2837 5.75613 20.206 5.64493L20.2061 5.64493C21.6248 5.59073 23.0234 5.76158 24.0758 5.9495C24.5998 6.04308 25.033 6.13997 25.3336 6.21304C25.4838 6.24955 25.6006 6.28004 25.6788 6.30109C25.6906 6.30424 25.7014 6.30719 25.7114 6.30991C25.7346 6.31625 25.7531 6.32137 25.7664 6.32513L25.7872 6.33102L25.7916 6.33229L25.7919 6.33239C26.3656 6.50004 27.3845 6.80329 28.5007 7.37105L28.5009 7.37112C30.0978 8.18293 30.9134 9.03626 31.6616 9.92574C31.7648 10.0484 31.8679 10.1735 31.9726 10.3005C32.6363 11.1057 33.3621 11.9863 34.5709 12.809L34.5711 12.8091C36.3716 14.0335 37.7357 14.1055 38.9534 14.1674L38.958 14.1676C40.0976 14.2255 41.0767 14.2753 42.4346 15.2503L42.4347 15.2504C45.4182 17.392 46.145 21.0086 46.2927 21.7594L46.2927 21.7598C46.457 22.5927 46.9834 25.805 45.1793 28.8056C43.3881 31.784 40.3551 32.8075 39.1461 33.2102C37.208 33.8556 36.0126 34.0084 34.848 34.1225C34.7332 34.1337 34.6183 34.1446 34.5028 34.1556C33.4178 34.2583 32.2711 34.367 30.5882 34.8303C26.8427 35.8602 24.9109 37.6885 23.1885 39.3185C23.1483 39.3566 23.1082 39.3945 23.0683 39.4323C21.3483 41.0587 19.8242 42.4407 16.7284 42.8841Z"
                      stroke="#A2AECB"
                      strokeWidth="1.5"
                    />
                    <path
                      id="changedColor"
                      d="M2.90278 10.9231C2.85335 11.6347 2.85344 11.6347 2.85354 11.6347L2.85379 11.6348L2.85448 11.6348L2.85662 11.6351L2.8639 11.6362L2.89027 11.6397C2.91302 11.6428 2.94599 11.6471 2.98853 11.6525C3.07358 11.6633 3.19694 11.6782 3.35326 11.6954C3.66577 11.7297 4.11077 11.773 4.64547 11.8095C5.71199 11.8823 7.14857 11.9289 8.60759 11.8195L8.6077 11.8195C10.2796 11.6939 11.3916 11.3998 12.4198 11.0336C12.804 10.8968 13.1554 10.759 13.5099 10.6199C14.1282 10.3774 14.7559 10.1312 15.5828 9.88055C15.6121 9.87168 15.644 9.86196 15.6784 9.85149C16.2298 9.68368 17.4157 9.32275 18.6409 9.18541C19.0698 9.13792 22.6077 8.79749 25.596 10.5837L2.90278 10.9231ZM2.90278 10.9231L2.85335 11.6347M2.90278 10.9231L2.85335 11.6347M39.6232 29.4568L39.6232 29.4568C40.8019 27.4801 41.2285 24.4001 39.8845 22.1558L39.8844 22.1557C39.0415 20.7474 37.9295 20.345 36.2563 19.7704L36.2481 19.7676C34.5731 19.1923 32.5064 18.4825 30.2839 16.2942C28.9655 14.9966 28.3672 13.9402 27.8801 13.0801C27.8277 12.9875 27.7765 12.8971 27.7258 12.809C27.2384 11.9606 26.7999 11.3042 25.5963 10.5839L39.6232 29.4568ZM39.6232 29.4568C37.8723 32.3937 34.3728 32.9344 31.6767 33.3242C29.9907 33.5673 29.0813 33.4527 27.9889 33.2897C27.932 33.2812 27.8747 33.2726 27.8167 33.2639C26.7095 33.0975 25.3935 32.8997 23.0833 32.9699L23.0706 32.9702C20.8599 33.0369 16.9085 33.1561 12.6558 34.8944C10.7913 35.6561 9.56891 36.4449 8.64166 37.0433C8.45383 37.1645 8.2781 37.2779 8.11161 37.3817C7.14174 37.9861 6.54603 38.229 5.58113 38.0454C4.22697 37.7862 3.06728 36.839 2.19173 35.8358C1.32607 34.844 0.81794 33.8883 0.760454 33.7772L0.760272 33.7769M39.6232 29.4568L0.760272 33.7769M2.83796 11.6325L2.82262 11.6297C0.987645 11.2912 -0.919829 11.0369 -2.44899 11.0703C-3.21488 11.0871 -3.84539 11.1757 -4.31168 11.3386C-4.77858 11.5018 -5.00873 11.7125 -5.10732 11.925C-5.20503 12.1358 -5.19995 12.3546 -4.73744 13.2021C-4.65743 13.3487 -4.56756 13.5082 -4.4697 13.6817C-4.03886 14.4459 -3.45336 15.4845 -2.87441 16.9127L-2.87434 16.9129C-1.32198 20.7452 -0.686194 24.968 -0.591334 27.6945L2.83796 11.6325ZM2.83796 11.6325L2.85335 11.6347M2.83796 11.6325L2.85335 11.6347M0.760272 33.7769C-0.183634 31.9562 -0.432924 29.7047 -0.504746 29.046C-0.564787 28.4953 -0.578077 28.0932 -0.587775 27.7997M0.760272 33.7769L-0.587775 27.7997M-0.587775 27.7997C-0.588986 27.7631 -0.590142 27.7281 -0.591326 27.6947L-0.587775 27.7997Z"
                      stroke="#A2AECB"
                      strokeWidth="1.5"
                    />
                    <path
                      id="changedColor"
                      d="M32.4382 21.9251L32.4381 21.9249C31.415 20.5405 30.4529 20.0474 29.3745 19.4976L29.3651 19.4928C28.2429 18.9207 27 18.2871 25.7729 16.5827L25.7729 16.5826C25.0292 15.5495 24.6859 14.6671 24.4204 13.9845C24.3819 13.8856 24.3451 13.791 24.3089 13.7006C24.0341 13.0144 23.8071 12.5874 23.1973 12.1705L23.1972 12.1704C22.0886 11.4123 20.7794 11.4365 19.1092 11.6304L19.1092 11.6304C15.7899 12.0153 13.8852 12.6883 12.2543 13.3012C12.1575 13.3375 12.0615 13.3738 11.9659 13.4099C10.4334 13.9884 9.02894 14.5186 6.8632 14.6361L6.86314 14.6361C4.24534 14.7778 2.12061 14.3078 0.559501 13.9624C0.475612 13.9439 0.39335 13.9257 0.312727 13.9079C-0.499965 13.7293 -1.07408 13.6167 -1.50343 13.6215C-1.86689 13.6255 -2.03302 13.7115 -2.14294 13.859C-2.14627 13.8821 -2.15505 13.9494 -2.14998 14.0874C-2.14142 14.32 -2.09893 14.6553 -2.01583 15.1188C-1.85001 16.0437 -1.545 17.3609 -1.12664 19.1537L-1.12662 19.1538C-0.923638 20.0239 -0.748191 20.6004 -0.596463 21.099C-0.563902 21.206 -0.532433 21.3094 -0.502019 21.4113C-0.324919 22.0049 -0.189397 22.5331 -0.118705 23.327C-0.0686369 23.8791 -0.0638999 24.3219 -0.0600685 24.68C-0.0587596 24.8024 -0.0575563 24.9148 -0.0546881 25.0184C-0.0434789 25.4231 -0.00913677 25.7685 0.141277 26.2602L0.141308 26.2603C0.27596 26.7006 0.624362 27.7797 1.58621 28.706L32.4382 21.9251ZM32.4382 21.9251C33.0159 22.7065 34.4949 24.7593 33.9905 26.8536L33.9904 26.8539C33.5412 28.7224 31.7613 29.6227 31.1838 29.9058L31.1837 29.9059C29.364 30.7986 27.5596 30.5278 25.4101 30.1561C23.4768 29.8213 22.5223 29.3869 21.634 28.9692C21.6047 28.9554 21.5754 28.9416 21.5461 28.9278C20.628 28.4956 19.7145 28.0655 18.0157 27.8126M32.4382 21.9251L18.0004 28.5338M5.07595 30.1767L5.07735 30.1768C5.95125 30.238 6.52912 30.0667 7.18936 29.7638C7.38024 29.6763 7.58829 29.5717 7.81698 29.4567C8.36851 29.1793 9.04012 28.8416 9.88067 28.5372M5.07595 30.1767L10.192 29.228M5.07595 30.1767C4.57664 30.1428 2.91963 29.989 1.58644 28.7062L5.07595 30.1767ZM9.88067 28.5372L10.192 29.228M9.88067 28.5372C9.8804 28.5373 9.88015 28.5374 9.8799 28.5375L10.192 29.228M9.88067 28.5372C10.0833 28.4636 13.7588 27.1776 18.0157 27.8126M10.192 29.228C10.3561 29.1683 13.9108 27.9238 18.0004 28.5338M18.0157 27.8126L18.0004 28.5338M18.0157 27.8126C18.0158 27.8126 18.0158 27.8126 18.0159 27.8126L18.0004 28.5338M-2.16476 13.8902L-2.16458 13.8899L-2.16476 13.8902Z"
                      stroke="#A2AECB"
                      strokeWidth="1.5"
                    />
                    <path
                      id="changedColor"
                      d="M16.9325 24.1249L16.932 24.1248C15.4723 23.8273 14.039 23.7554 12.7359 23.7073C12.6025 23.7024 12.4708 23.6977 12.3408 23.6931C11.1793 23.6519 10.1539 23.6156 9.25079 23.451C8.78612 23.3662 8.55459 23.2798 8.36666 23.2097L8.36345 23.2085L8.35258 23.2044C8.1338 23.1227 7.90001 23.0355 7.51576 23.0298C7.17224 23.0248 6.71891 23.0841 6.0161 23.2109C5.30157 23.3397 4.27889 23.5483 2.77171 23.8627C-0.183239 24.4788 -1.98646 24.7976 -3.23343 24.8625C-4.43643 24.9251 -5.06683 24.7483 -5.69699 24.3854C-5.82755 24.3096 -6.29272 24.0307 -6.76481 23.5554C-7.24048 23.0765 -7.68549 22.4362 -7.84059 21.6445C-8.03466 20.6521 -7.72589 19.6435 -7.12172 18.714C-6.5157 17.7818 -5.65142 16.9952 -4.87795 16.5061L-4.87775 16.506C-2.63802 15.0888 -0.103085 15.4932 2.06787 15.8665L2.06849 15.8666C3.86968 16.1746 4.98883 16.6715 6.10578 17.1675C6.2022 17.2103 6.2986 17.2531 6.39543 17.2958C7.64164 17.845 8.92728 18.3562 11.0532 18.4878C12.967 18.6067 14.4189 18.3462 15.5711 18.1395L15.593 18.1356L15.5932 18.1355C17.6766 17.7611 19.2387 17.1782 20.5186 16.7006C20.7991 16.596 21.066 16.4964 21.3219 16.4051C22.739 15.8999 23.815 15.6474 25.184 16.0084C26.492 16.3565 26.9848 16.977 27.1069 17.1386L16.9325 24.1249ZM16.9325 24.1249C19.1568 24.5797 21.3681 25.0145 23.6885 24.0417M16.9325 24.1249L23.6885 24.0417M23.6885 24.0417C24.0063 23.9082 24.8011 23.5734 25.6022 22.962C26.4037 22.3502 27.1599 21.5008 27.4782 20.3511L27.4783 20.3511C27.5164 20.2126 27.6567 19.7035 27.6652 19.069C27.6737 18.4321 27.549 17.7251 27.107 17.1389L23.6885 24.0417Z"
                      stroke="#A2AECB"
                      strokeWidth="1.5"
                    />
                  </g>
                  <circle
                    id="changedColor"
                    cx="11.5"
                    cy="11.5"
                    r="10.75"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                  />
                </svg>
              </Icon>
            </TabItem>
          )}
          {props.tab === "grow" || props.tab === "growVideo" ? (
            <TabItemSelected to="/grow" onClick={props.growOptionHandler}>
              <Title>Grow</Title>
              <Icon>
                <IconImg src="/images/components/Sidebar/GrowSelected.svg" />
              </Icon>
            </TabItemSelected>
          ) : (
            <TabItem to="/grow" onClick={props.growOptionHandler}>
              <Title>Grow</Title>
              <Icon>
                <svg
                  width="21"
                  height="23"
                  viewBox="0 0 21 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="changedColor"
                    d="M14.5482 21.9996H8.64288C8.48004 21.9997 8.32219 21.942 8.19604 21.8364C8.06989 21.7308 7.9832 21.5837 7.95063 21.4201L6.82042 15.6243C6.79947 15.519 6.80161 15.4103 6.82669 15.3059C6.85177 15.2016 6.89915 15.1043 6.96542 15.0211C7.03168 14.9379 7.11516 14.8708 7.20981 14.8248C7.30447 14.7787 7.40792 14.7549 7.51268 14.7549H15.6784C15.7833 14.7547 15.8868 14.7785 15.9816 14.8245C16.0764 14.8705 16.16 14.9375 16.2263 15.0207C16.2927 15.104 16.3402 15.2013 16.3653 15.3057C16.3904 15.4101 16.3926 15.5189 16.3716 15.6243L15.2414 21.4201C15.2086 21.5838 15.1218 21.7309 14.9955 21.8365C14.8692 21.9421 14.7112 21.9997 14.5482 21.9996V21.9996Z"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M3.7168 11.3148L6.01363 5.95215"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M0.849121 8.36179L6.01338 5.95215"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M0.812012 4.26855L6.01346 5.95251"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M3.37354 1.42285L6.18018 6.24027"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M11.8973 6.46292L6.01367 5.95215"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M10.5257 2.66992L6.01367 5.95224"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M7.2782 1L6.01367 5.95232"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M12.5684 9.0166L16.3166 9.18686"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M14.728 5.63574L16.3164 9.18694"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M18.1007 5.94727L16.3164 9.18679"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M18.1815 12.4261L16.3164 9.1875"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M20.0538 8.83203L16.3164 9.18743"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M6.18066 6.06836C6.83289 7.00617 9.76925 12.1027 9.76925 14.6649"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M16.3164 9.0166C15.236 10.2977 14.3098 13.0507 13.8472 14.6658"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Icon>
            </TabItem>
          )}
          {props.tab === "settings" ? (
            <TabItemSelected
              to="/settings"
              onClick={props.settingsOptionHandler}
            >
              <Title>Settings</Title>
              <Icon>
                <IconImg src="/images/components/Sidebar/SettingsSelected.svg" />
              </Icon>
            </TabItemSelected>
          ) : (
            <TabItem to="/settings" onClick={props.settingsOptionHandler}>
              <Title>Settings</Title>
              <Icon>
                <svg
                  width="22"
                  height="21"
                  viewBox="0 0 22 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="changedColor"
                    d="M7.51318 1L8.95714 4.40555H13.0438L14.4868 1H7.51318Z"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M17.5082 2.74316L15.2832 5.69827L17.3293 9.2355L21 8.78052L17.5082 2.74316Z"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M20.992 12.3403L17.3231 11.8672L15.2598 15.3944L17.4711 18.3604L20.992 12.3403Z"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M4.49182 2.74316L6.71678 5.69827L4.67073 9.2355L1 8.78052L4.49182 2.74316Z"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M1.0083 12.3403L4.67721 11.8672L6.74052 15.3944L4.52919 18.3604L1.0083 12.3403Z"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    id="changedColor"
                    d="M14.4868 20.0716L13.0438 16.666H8.95714L7.51318 20.0716H14.4868Z"
                    stroke="#A2AECB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Icon>
            </TabItem>
          )}
        </SideTab>
      </SideTopGrouping>
    </SidebarWrapper>
    // </BG>
  );
};
export default SidebarPopUp;
